<template>
  <div>
    <div class="modal-pdv modal-full show" :id="modalId" tabindex="-1" v-if="modal">
      <div class="modal-pdv-content pt-0">
        <div class="container-fluid p-0">
          <div class="pt-2" v-show="modal === 1">
            <div class="px-3">
              <label class="mb-0">Pesquisar Cliente <span v-if="!isNaN(termo)">{{termo | maskPhone}}</span></label>
              <div class="d-flex justify-content-between mb-1">
                <div class="mr-1 w-100">
                  <input type="search" class="form-control" placeholder="Nome ou telefone (com DDD)" :id="'pesquisarNomeCliente' + modalId" v-model="termo"
                         @search="searchCliente()"/>
                </div>
                <button type="button" class="btn btn-primary text-nowrap" :disabled="!termo.trim()" title="Pesquisar cliente"
                        @click="searchCliente()" style="width: 80px"><i class="fa fa-search"></i></button>
              </div>
            </div>
            <div class="height-90 table-cliente px-3">
              <div :id="'tableCliente' + modalId" v-show="clientes.length" tabindex="0">
                <div class="row no-gutters table-item" v-for="c in clientes">
                  <div class="col-8 pointer" @click="editarCliente(c)">
                    <div class="d-flex align-items-center font-weight-bold">
                      <div v-if="c.telefone">{{c.telefone | phone}}</div><span v-else>Sem telefone</span>
                      <a href="javascript:" class="text-primary ml-2" style="font-size: 12px"><i class="fa fa-edit"></i></a>
                    </div>
                    <div>{{c.nome_cliente}} <span v-if="c.nome_fantasia">({{c.nome_fantasia}})</span></div>
                    <div class="small" v-if="c.endereco">{{c.endereco}}, {{c.numero}}, {{c.bairro}} {{ c.taxa_entrega }}</div>
                    <div class="small" v-else>(Sem endereço)</div>
                  </div>
                  <div class="col-4 text-right">
                    <button v-if="!view" class="btn btn-third" style="width: 94px" type="button" @click="retornar(c)">
                      <i class="fa fa-check mr-1"></i><span class="d-block small">Selecionar</span>
                    </button>
                  </div>
                </div>
              </div>
              <loading v-if="load"/>
              <div class="my-5 text-center" v-else>
                <div class="px-5" v-if="!pesquisou">
                  <i class="fa fa-lightbulb fa-2x text-secondary"></i>
                  <p class="mt-3 mb-4">Para cadastrar um novo cliente, informe o telefone ou nome e aperte o botão pesquisar.</p>
                </div>
                <div class="px-5" v-else-if="!clientes.length">
                  <p class="mb-4">Cliente não encontrado, deseja realizar um novo cadastro?</p>
                </div>
                <button type="button" class="btn btn-success p-3" @click="novoCliente(true)">
                  <i class="fa fa-user-plus mr-1"></i> Cadastrar novo cliente
                </button>
              </div>
            </div>
          </div>
          <div class="height-100 dados-cliente px-3" v-show="modal === 2">
            <div :id="'editCliente' + modalId" style="padding-top: 16px">
              <div v-if="dados.id_cliente">
                <modal-menu :menus="menus" :selected="1" @changeMenu="changeMenu"/>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="font-weight-bold mb-0">{{ dados.id_cliente ? 'Cliente' : 'Novo Cliente' }}</h6>
                    <div>
                      <div v-if="!editar">
                        <button type="button" class="btn btn-outline-dark btn-sm mr-2" @click="deletarCliente()"><i class="fa fa-trash-alt mr-1"></i> Deletar</button>
                        <button type="button" id="btnEditarCliente" class="btn btn-secondary btn-sm" @click="toggleEditar()">
                          <i class="fa fa-edit mr-1"></i> Editar
                        </button>
                      </div>
                      <button type="button" class="btn btn-dark btn-sm" @click="editarCliente(dados)" v-else>
                        Cancelar
                      </button>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6 mb-2">
                      <label class="mb-0">Nome / Razão Social*</label>
                      <input type="text" :id="'clienteNome' + modalId" v-model="dados.nome_cliente"  class="form-control" placeholder="Nome ou razão social do cliente" :disabled="!editar" maxlength="128"/>
                    </div>
                    <div class="col-md-6 mb-2" v-if="!load">
                      <label class="mb-0">
                        Telefone* <a v-if="dados.telefone && dados.id_cliente" :href="`https://wa.me/55${dados.telefone}`" class="text-success" target="_blank"><span class="icon-whatsapp"></span></a>
                      </label>
                      <the-mask :mask="['(##) ####-####', '(##) #####-####']" :id="'clienteTelefone' + modalId" type="tel" class="form-control" v-model="dados.telefone" minlength="12" placeholder="(##) ####-####" :disabled="!editar"/>
                    </div>
                    <div class="col-md-6 mb-2" v-if="!load">
                      <label class="mb-0">CPF / CNPJ</label>
                      <the-mask typeof="number" :mask="['###.###.###-##', '##.###.###/####-##']" :id="'cpf_cnpj' + modalId" class="form-control" v-model="dados.cpf_cnpj" placeholder="CPF ou CNPJ" :disabled="!editar"/>
                    </div>
                    <div class="col-md-6 mb-2">
                      <label class="mb-0">Tipo Contato*</label>
                      <select class="form-control" v-model="dados.tipo_contato" :disabled="!editar" required>
                        <option value="1">Cliente</option>
                        <option value="2">Fornecedor</option>
                      </select>
                    </div>
                  </div>
                  <h6 class="font-weight-bold mb-2">Dados Fiscais</h6>
                  <div class="row mb-2">
                    <div class="col-md-6 mb-2">
                      <label class="mb-0">Contribuinte</label>
                      <select class="form-control" v-model="dados.tipo_contribuinte" :disabled="!editar" required>
                        <option value="1">Contribuinte ICMS</option>
                        <option value="2">Contribuinte isento</option>
                        <option value="9">Não Contribuinte</option>
                      </select>
                    </div>
                    <div class="col-md-6 mb-2" v-if="!load">
                      <label class="mb-0">Inscrição Estadual</label>
                      <the-mask type="tel" :mask="['###.###.###.###.##']" class="form-control" placeholder="###.###.###.###.##" v-model="dados.inscricao_estadual" :disabled="!editar"/>
                    </div>
                    <div class="col-md-6 mb-2">
                      <label class="mb-0">Nome Fantasia</label>
                      <input type="text" v-model="dados.nome_fantasia"  class="form-control" placeholder="Nome fantasia (empresa)" :disabled="!editar" maxlength="128"/>
                    </div>
                  </div>
                  <div class="small mb-md-3" v-if="dados.id_cliente">ID: {{dados.id_cliente}}</div>
                </div>
                <div class="col-md-6">
                  <hr class="d-md-none">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="font-weight-bold mb-0">Endereços</h6>
                    <button class="btn btn-secondary btn-sm" type="button" @click="novoEndereco()">Novo Endereço</button>
                  </div>
                  <div v-if="dados.enderecos">
                    <div class="card mb-3" v-for="(e, index) in dados.enderecos">
                      <div class="p-3">
                        <div class="d-flex align-items-center justify-content-between">
                          <div class="pr-3" @click="selEndereco(e, e.is_default, index)">
                            <input type="radio" name="selEndereco" :checked="e.is_default === '1'">
                          </div>
                          <a href="javascript:" class="small w-75 text-dark text-decoration-none" @click="selEndereco(e, e.is_default, index)" :class="{'text-ellipsis': menuE === index}">
                            <h6 class="font-weight-bold mb-0">{{ e.tipo_endereco | tipoendereco }}</h6>
                            <div>
                              <span v-if="e.logradouro">{{ e.logradouro }}, </span><span v-if="e.numero">{{ e.numero }}, </span><span v-if="e.bairro">{{ e.bairro }},</span> {{e.nome_cidade}} - {{e.sigla_estado}}<span v-if="e.complemento">, {{ e.complemento }}</span>
                            </div>
                          </a>
                          <div class="text-right text-nowrap">
                            <button type="button" class="btn text-secondary btn-sm small" @click="editarEndereco(index)" title="Editar endereço" v-if="menuE !== index"><i class="fa fa-edit"></i></button>
                            <button type="button" class="btn text-dark btn-sm small" @click="removerEndereco(e)" title="Remover endereço"><i class="fa fa-trash-alt"></i></button>
                          </div>
                        </div>
                        <div v-if="menuE === index">
                          <hr>
                          <div class="row">
                            <div class="col-md-6 mb-2">
                              <label class="mb-0">CEP</label>
                              <div class="d-flex justify-content-center" v-if="!load">
                                <the-mask typeof="number" :mask="['#####-###']" class="form-control" v-model="e.cep" id="cep" placeholder="#####-###" :disabled="!editar"
                                          @keydown.native.enter.prevent="buscarDadosCep(e)"/>
                                <button :disabled="!editar" class="btn btn-third ml-1" type="button" @click="buscarDadosCep(e)"><i class="fa fa-search"></i></button>
                              </div>
                            </div>
                            <div class="col-md-6 mb-2">
                              <label class="mb-0">Tipo Endereço*</label>
                              <select class="form-control" v-model="e.tipo_endereco" :disabled="!editar">
                                <option value="3">Outros</option>
                                <option value="1">Casa</option>
                                <option value="2">Trabalho</option>
                              </select>
                            </div>
                            <div class="col-md-8 mb-2">
                              <label class="mb-0">Logradouro*</label>
                              <input type="text" v-model="e.logradouro" class="form-control" id="endereco" placeholder="Informe o Endereço" maxlength="256" :disabled="!editar"/>
                            </div>
                            <div class="col-md-4 mb-2">
                              <label class="mb-0">Número</label>
                              <input type="text" class="form-control" id="numeroEndereco" v-model="e.numero" placeholder="Número" maxlength="12" :disabled="!editar"/>
                            </div>
                            <div class="col-md-6 mb-2">
                              <label class="mb-0">Bairro</label>
                              <input type="text" v-model="e.bairro" class="form-control" id="bairro" placeholder="Informe o Bairro" maxlength="45" :disabled="!editar"/>
                            </div>
                            <div class="col-md-6 mb-2">
                              <label class="mb-0">Cidade*</label>
                              <div class="form-control bg-light" style="overflow: hidden">
                                <span v-if="e.nome_cidade">{{e.nome_cidade}} - {{e.sigla_estado}}</span>
                              </div>
                            </div>
                            <div class="col-md-12 mb-2" v-if="zonas.length">
                              <label class="mb-0"><i class="fa fa-map-marker-alt text-warning"></i> Taxa de Entrega</label>
                              <div class="d-flex">
                                <modal-select class="w-100" :options="zonas" :value="e.id_zona" id="zonaPdv" :disabled="!editar" placeholder="Buscar taxas de entrega" @selected="selecionarZona"/>
                                <button class="btn btn-outline-dark ml-1" style="width: 70px" @click="e.id_zona = null" :disabled="!editar || !e.id_zona" title="Remover Taxa de Entrega'">
                                  <i class="fa fa-times"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <label class="mb-0">Complemento / Observações</label>
                              <textarea class="form-control" v-model="e.complemento" :disabled="!editar" placeholder="Complemento ou observações da entrega."
                                        maxlength="255" style="resize: none"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <a href="javascript:" class="text-center text-dark p-1 border-top" v-if="menuE === index" @click="menuE = null"><i class="fa fa-chevron-up"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light p-2 mt-2 border-top d-flex justify-content-between">
          <button type="button" class="btn btn-dark p-3" @click="fecharModal(false)">
            <i class="fa fa-chevron-left mr-2"></i>
            Voltar
          </button>
          <button type="button" class="btn btn-outline-success p-3" id="btnSalvarCliente" @click="fecharModal(true)" v-if="finalizar && modal === 1">
            Avançar
            <i class="fa fa-chevron-right mr-2"></i>
          </button>
          <button class="btn btn-success p-3" v-if="modal === 2 && (!view || editar)" @click="cadastrarOrEdit()">
            <i class="fa fa-check"></i>
            <span class="ml-2">{{editar ? 'Salvar' : 'Selecionar'}}</span>
          </button>
        </div>
      </div>
    </div>

    <div v-show="modalVendas">
      <admin-vendas :id_cliente="dados.id_cliente" :opened="modalVendas" @closeModal="modalVendas = false" @closeAll="toggleModal(false)"/>
    </div>

    <cliente-debito/>
    <cliente-credito/>
  </div>
</template>

<script>
  import ModalMenu from "@/components/commons/ModalMenu";
  import ClienteDebito from "@/views/comanda/pdv/ClienteDebito";
  import Loading from "@/components/commons/Loading";
  import ModalSelect from "@/components/commons/ModalSelect";
  import ClienteCredito from "@/views/comanda/pdv/ClienteCredito";

  export default {
    name: "cliente",
    components: {ClienteCredito, ModalSelect, Loading, ClienteDebito, ModalMenu},
    props: ['view'],
    data() {
      return {
        modalId: this.$helpers.ID(),
        token: localStorage.getItem('key'),
        modal: 0,
        modalCliente: false,
        termo: '',
        editar: false,
        selecionado: false,
        finalizar: false,
        tableCliente: null,
        editCliente: null,
        modalVendas: false,
        load: false,

        menus: [
          { nome: 'Dados', active: true },
          { nome: 'Vendas', active: true },
          { nome: 'Débitos', active: true },
          { nome: 'Créditos', active: true },
        ],

        clientes: [],
        dados: {
          nome_cliente: '',
          tipo_contato: '1',
          telefone: '',
          email: '',
          cpf_cnpj: '',
          enderecos: []
        },

        menuE: null,
        pesquisou: false,
        pesquisa: {
          relatorio: '1',
          termo: '',
          page: 0
        }
      }
    },

    methods: {
      searchCliente() {
        this.clientes = [];
        this.pesquisa.termo = '';

        if (this.termo.trim()) {
          const phone = this.termo.replace(/\s/g, "").replace(/[-(),]/g,'');

          if (!isNaN(phone)) {
            if (phone.length < 8) {
              this.$swal('Por favor informe o telefone válido com no mínimo 8 dígitos').then(() => {
                this.focusEl('pesquisarNomeCliente');
              });

              return;

            } else if (phone.length < 10) {
              this.termo = (this.empresa.ddd || '') + this.termo;
            }

            let termo = this.termo.replace(/\D/g,'');

            if (termo && termo.startsWith('55')) {
              termo = termo.substring(2, termo.length);
            }

            this.termo = termo;
          }

          this.pesquisa.termo = this.termo.trim();
          this.buscarClientes();
        }
      },

      clearSearch(focus) {
        this.clientes = [];
        this.termo = '';
        this.pesquisa.termo = '';

        if (focus) {
          this.focusEl('pesquisarNomeCliente');
        }
      },

      toggleModal(n) {
        this.modal = n;
        this.$nextTick(() => {
          this.$helpers.toggleModal(n, this.modalId, this.fecharModal);
          if (n) {
            this.tableCliente = document.getElementById('tableCliente' + this.modalId);
            this.editCliente = document.getElementById('editCliente' + this.modalId);
            this.$helpers.scrollTop(this.modalId);

            if (n === 1) {
              this.focusEl('pesquisarNomeCliente');
            }
          }
        });
      },

      buscarClientes(page) {
        if (this.load) {
          return;
        }

        this.load = true;
        this.clientes = [];
        this.pesquisa.page = page || 0;
        this.pesquisou = true;

        this.$http.get('pdv/clientes/pesquisar/' + this.token, {params: this.pesquisa})
          .then(response => {
            this.load = false;
            this.clientes = response.data || [];

            if (!this.clientes.length) {
              this.$swal({
                text: `Nenhum cliente encontrado. Deseja realizar seu cadastro?`,
                buttons: ["Não", "Sim"],
                dangerMode: false
              }).then((result) => {
                if (result) {
                  this.novoCliente();

                } else {
                  this.focusEl('pesquisarNomeCliente');
                }
              });
            }

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      buscarClienteId(id, callback) {
        this.load = true;
        this.$store.state.load = "Buscando dados do cliente";
        this.$http.get('pdv/clientes/' + this.token + '/' + id)
          .then(res => {
            this.$store.state.load = false;
            this.load = false;

            if (!res.data || !res.data.id_cliente) {
              return;
            }

            this.selecionado = true;
            this.dados = res.data;
            this.$nextTick(() => {
              if (this.editCliente) this.editCliente.scrollIntoView();
            })

            if (!this.dados.enderecos.length) {
              this.novoEndereco(this.dados);
            }

            if (callback) callback();

          }, res => {
            this.editar = false;
            this.load = false;
            this.$store.state.load = false;
            this.$swal(res.data.msg);
          });
      },

      buscarDadosCep(e) {
        e.cep = e.cep ? e.cep.replace('-','') : '';

        if (!e.cep || e.cep.length !== 8 || this.$store.state.load) {
          return;
        }

        this.$store.state.load = true;
        this.$http.get('https://viacep.com.br/ws/'+ e.cep +'/json', { skipHeader: true })
          .then(response => {
            this.$store.state.load = false;
            const endereco = response.data;

            if (!endereco.erro) {
              e.id_cidade = null;
              e.logradouro = endereco.logradouro || '';
              e.bairro = endereco.bairro || '';
              e.numero = '';
              e.complemento = '';
              e.ibge = endereco.ibge;
              e.nome_cidade = endereco.localidade;
              e.sigla_estado = endereco.uf;
              this.$helpers.focusElement((e.logradouro ? 'numeroEndereco' : 'endereco'));

              if (e.bairro && this.zonas.length) {
                const bairro = this.zonas.find(z => z.nome_zona.toLowerCase() === e.bairro.toLowerCase());
                e.id_zona = bairro ? bairro.id_zona : null;
              }

            } else {
              this.$swal('CEP não encontrado. Por favor informe um CEP válido.').then(() => {
                this.$helpers.focusElement('cep')
              });
            }

          }, res => {
            console.log(res);
            this.$store.state.load = false;
          });
      },

      selecionarZona(zona) {
        if (zona) {
          this.dados.enderecos[this.menuE].id_zona = zona.id_zona;
        }
      },

      editarCliente(dados) {
        this.editar = false;
        this.modal = 2;
        this.menuE = null;

        if (dados.id_cliente) {
          this.buscarClienteId(dados.id_cliente);

        } else {
          this.fecharModal(false);
        }
      },

      toggleEditar() {
        this.editar = true;
        this.focusEl('clienteNome');
      },

      novoCliente(clear) {
        if (clear) {
          this.pesquisa.termo = this.termo;
        }

        this.clearDados(2);
        this.editar = true;

        if (this.pesquisa.termo) {
          if (!isNaN(this.pesquisa.termo)) {
            this.dados.telefone = this.pesquisa.termo;
            this.focusEl('clienteNome');

          } else {
            this.dados.nome_cliente = this.pesquisa.termo;
            this.focusEl('clienteTelefone');
          }

          this.scrollModal();

        } else {
          this.focusEl('clienteNome');
        }

        this.novoEndereco({});
      },

      cadastrarOrEdit() {
        if (this.dados.tipo_contato === '1' && (!this.dados.telefone || !this.dados.telefone.trim() || this.dados.telefone.length < 10)) {
          this.$swal('Quando o tipo de contato for Cliente é obrigatório informar um telefone de contato. No formato (DDD) + numero.').then(() => {
            this.focusEl('clienteTelefone');
          });

          return;
        }

        if (this.dados.cpf_cnpj && this.dados.cpf_cnpj.trim() && (![11,14].includes(this.dados.cpf_cnpj.length))) {
          this.$swal('Por favor informe um CPF ou CNPJ válido.').then(() => {
            this.focusEl('cpf_cnpj');
          });

          return;
        }

        let valid = true;

        this.dados.enderecos.forEach((e) => {
          if (!e.logradouro || !e.logradouro.trim()) {
            valid = false;
          }
        });

        if (this.dados.enderecos.length > 1 && !valid) {
          this.$swal('O logradouro e a cidade são obrigatórios. Para informar a cidade basta pesquisar o CEP. Remova o endereço ou complete o cadastro.');
          return;

        } else if (!valid) {
          this.dados.enderecos = [];
        }

        if (this.editar) {
          let base = "pdv/clientes/inserir/" + this.token;

          if (this.dados.id_cliente) {
            base = "pdv/clientes/editar/" + this.token + '/' + this.dados.id_cliente;
          }

          this.$store.state.load = "Enviando dados do cliente";

          this.$http.post(base, this.dados)
            .then(res => {
              this.$store.state.load = false;

              if (!res.data.id_cliente) {
                if (res.data.editar && res.data.editar.id_cliente) {
                  this.$swal({
                    text: `Telefone já cadastrado. Deseja editar as informações do cliente?\n\nNome: ${res.data.editar.nome_cliente}.`,
                    buttons: ['Não', 'Sim']
                  }).then(ask => {
                    if (ask) {
                      this.editar = true;
                      const isEditar = !!this.dados.id_cliente;
                      const endereco = this.dados.enderecos;

                      this.buscarClienteId(res.data.editar.id_cliente, () => {
                        this.focusEl('clienteNome');

                        if (!isEditar && endereco.length && this.dados.enderecos.length < 3) {
                          this.dados.enderecos = this.dados.enderecos.map(e => { return { ...e, is_default: '0' } });
                          this.dados.enderecos.unshift({
                            tipo_endereco: (this.dados.enderecos.length + 1).toString(),
                            logradouro: endereco[0].logradouro,
                            numero: endereco[0].numero,
                            bairro: endereco[0].bairro,
                            complemento: endereco[0].complemento,
                            cep: endereco[0].cep,
                            id_cidade: endereco[0].id_cidade || '',
                            nome_cidade: endereco[0].nome_cidade || '',
                            ibge: endereco[0].ibge || '',
                            sigla_estado: endereco[0].sigla_estado || '',
                            is_default: '1'
                          });
                        }
                      });
                    }
                  });
                }

                return;
              }

              if (!this.dados.id_cliente) {
                this.dados.id_cliente = res.data.id_cliente;
              }

              const end_default = this.dados.enderecos.find(e => e.is_default === '1') || {};
              this.dados.endereco = end_default.logradouro || '';
              this.dados.numero = end_default.numero || '';
              this.dados.bairro = end_default.bairro || '';
              this.dados.id_zona = end_default.id_zona || null;

              if (this.view) {
                this.editar = false;
                this.menuE = null;
                this.buscarClienteId(this.dados.id_cliente);

              } else {
                this.toggleModal(false);
                this.$emit('retorno', this.dados, this.finalizar);
              }

            }, res => {
              this.$store.state.load = false;
              if (res.data) {
                this.$swal(res.data.msg || 'Erro temporário');
              }
            });

        } else {
          this.retornar(this.dados)
        }
      },

      deletarCliente() {
        this.$swal({
          text: 'Deseja realmente remover este cliente?',
          buttons: ['Não', 'Sim'],
          dangerMode: true
        }).then(res => {
          if (res) {
            this.$store.state.load = "Deletando cliente";
            this.$http.post('pdv/clientes/remover/' + this.token + '/' + this.dados.id_cliente, this.dados)
              .then(res => {
                this.$store.state.load = false;
                this.modal = 1;
                this.buscarClientes();
                this.$emit('remover');

              }, res => {
                this.$store.state.load = false;
                this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
              });
          }
        });
      },

      selEndereco(data, is_default, index) {
        this.dados.enderecos = this.dados.enderecos.map(e => { return { ...e, is_default: '0' } });
        this.$nextTick(() => {
          this.dados.enderecos[index].is_default = '1';

          if (is_default !== '1') {
            this.editar = true;
            this.menuE = null;

          } else if (this.menuE !== index) {
            this.editarEndereco(index);

          } else {
            this.menuE = null;
          }
        })
      },

      novoEndereco(data) {
        if (this.dados.enderecos.length === 3) {
          this.$swal('O máximo de endereço por cliente é 3.');
          return;
        }

        const dados = data || {};
        this.dados.enderecos = this.dados.enderecos.map(e => { return { ...e, is_default: '0' } });
        this.dados.enderecos.unshift({
          tipo_endereco: (this.dados.enderecos.length + 1).toString(),
          logradouro: dados.endereco || '',
          numero: dados.numero || '',
          bairro: dados.bairro || '',
          id_cidade: dados.id_cidade || this.empresa.id_cidade,
          nome_cidade: dados.nome_cidade || this.empresa.nome_cidade,
          sigla_estado: dados.sigla_estado || this.empresa.sigla_estado,
          cep: dados.cep || this.empresa.cep || '',
          ibge: dados.ibge || this.empresa.ibge || '',
          complemento: dados.complemento || '',
          id_zona: null,
          is_default: '1'
        });

        this.menuE = 0;

        if (!data) {
          this.editar = true;
          this.$nextTick(() => {
            this.$helpers.focusElement((!this.empresa.cep ? 'cep' : 'endereco'))
          });
        }
      },

      removerEndereco(e) {
        this.editar = true;
        this.dados.enderecos = this.dados.enderecos.filter(end => end !== e);

        if (this.dados.enderecos.length && e.is_default) {
          this.dados.enderecos[0].is_default = '1';
        }
      },

      editarEndereco(index) {
        this.menuE = index;
        this.editar = true;
        this.$nextTick(() => {
          this.$helpers.focusElement('endereco')
        });
      },

      changeMenu(m) {
        if (m === 2) {
          this.modalVendas = true;

        } else if (m === 3) {
          this.$emit('openDebitos', this.dados);

        } if (m === 4) {
          this.$emit('openCredito', this.dados);
        }
      },

      retornar(dados) {
        if (dados) {
          this.$store.state.load = "Selecionando cliente";
          setTimeout(() => {
            this.$store.state.load = false;
            this.toggleModal(false);
            this.$emit('retorno', dados, this.finalizar);
          }, 500);
        }
      },

      clearDados(modal) {
        this.dados = {
          nome_cliente: '',
          tipo_contato: '1',
          telefone: '',
          cpf_cnpj: '',
          inscricao_estadual: '',
          tipo_contribuinte: '9',
          nome_fantasia: '',
          email: '',
          enderecos: []
        };

        this.modal = modal || 1;
        this.editar = false;
        this.selecionado = false;
        this.menuE = null;
      },

      fecharModal(finalizar) {
        if (this.modal === 2) {
          this.modal = 1;
          this.$nextTick(() => {
            this.focusEl('pesquisarNomeCliente');
          })

        } else {
          this.toggleModal(false);
          this.$emit('retorno', null, finalizar);
        }
      },

      scrollModal() {
        if (!this.is_mobile) {
          if (this.tableCliente) this.tableCliente.scrollIntoView();
          if (this.editCliente) this.editCliente.scrollIntoView();
        }
      },

      focusEl(el) {
        this.$helpers.focusElement(el + this.modalId);
      },

      iniciar(id, finalizar, callback) {
        this.finalizar = finalizar;
        this.pesquisou = false;
        this.clearDados();
        this.clearSearch();
        this.toggleModal(id ? 2 : 1);

        if (id) {
          this.editar = true;
          this.buscarClienteId(id);
        }

        setTimeout(() => {
          this.scrollModal();
        }, 500);

        if (callback) {
          callback()
        }
      }
    },

    computed: {
      empresa() {
        return this.$store.state.dataUser
      },

      zonas() {
        return this.$store.state.zonasEntrega
      }
    },

    filters: {
      tipoendereco(tipo) {
        switch (tipo) {
          case '1':
            return 'Casa';
          case '2':
            return 'Trabalho';
          default:
            return 'Outros';
        }
      },

      maskPhone(term) {
        if (!term) return "";
        if (isNaN(term)) return term;
        term = term.replace(/\D/g,'')
        term = term.replace(/(\d{2})(\d)/,"($1) $2")
        term = term.replace(/(\d)(\d{4})$/,"$1-$2")
        return term;
      }
    }
  }
</script>

<style scoped>
  .height-90.table-cliente {
    border-top: 1px solid #eaecf4;
    margin-top: 12px;
    height: calc(100vh - 218px);
  }

  .height-100.dados-cliente {
    height: calc(100vh - 137px);
  }

  .table-item {
    align-items: center;
    border-bottom: 1px solid #eaecf4;
    padding: 10px 0;
  }
</style>
